import { render, staticRenderFns } from "./workload-admin-requests.vue?vue&type=template&id=44c5a20b&scoped=true&"
import script from "./workload-admin-requests.vue?vue&type=script&lang=js&"
export * from "./workload-admin-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5a20b",
  null
  
)

export default component.exports